export default "__VITE_ASSET__C_UUH$A7__"